export const InstanceRetrievalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clip-path="url(#a)">
      <g clip-path="url(#b)">
        <path
          stroke="#D7CA00"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M10.074 5.234h.008m-8.305 5.531L5.234 7.31c.642-.618 1.433-.618 2.074 0l1.5 1.5"
        />
        <path
          stroke="#D7CA00"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M14.222 8.514V4.89a3.111 3.111 0 0 0-3.111-3.112H4.889A3.111 3.111 0 0 0 1.777 4.89v6.222a3.111 3.111 0 0 0 3.112 3.111H8.39"
        />
        <path
          stroke="#D7CA00"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9.556 11.556a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm3.467 1.465 1.2 1.2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M.797.797h14.406v14.406H.797z" />
      </clipPath>
    </defs>
  </svg>
);
